import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { environment } from 'src/environments/environment';
import { provideLoginRoutes } from 'login';
import { ImportGuideComponent } from './components/import-guide/import-guide.component';
import { NotAuthorisedPageComponent } from './pages/not-authorised/not-authorised-page.component';
import { NotFoundPageComponent } from './pages/not-found/not-found-page.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'app' },
  {
    path: 'app',
    canActivate: [AuthGuard.canLoadApp],
    loadChildren: () => import('./framework/framework.routes').then((m) => m.routes),
    }, {
  component: ImportGuideComponent,
  path: 'help'
}, {
  component: NotAuthorisedPageComponent,
  path: 'not-authorised'
}];

// Add login routes dynamically if `loginHost` is not defined in the environment.
if (!environment.loginHost) {
  routes.push(...provideLoginRoutes({ loginHost: environment.loginHost }));
}

// Catch-all route for 404
routes.push({
  path: '**',
  component: NotFoundPageComponent,
  title: 'Reval - Page Not Found'
});

export default routes;

